const isLocalhost = () => {
  return window.location.hostname === 'localhost';
};

const isTest = () => {
  return process.env.NODE_ENV === 'test';
};

const isProduction = () => {
  return process.env.NODE_ENV === 'production';
};


export {
  isLocalhost,
  isTest,
  isProduction
};

